
export default {
    props: {
        borderColor: {
            type: String,
            default: '',
        },
        floatedClass: {
            type: String,
            default: '',
        },
        noteContent: {
            type: Array,
            default: () => {
                return []
            },
        },
        articleSlugs: {
            type: Array,
            default: () => {
                return []
            },
        },
        src: {
            type: String,
            default: '',
        },
        noPic: Boolean,
    },

    data() {
        return {
            articles: [],
        }
    },

    mounted() {
        if (this.articleSlugs && this.articleSlugs.length) {
            this.articleSlugs.map((el) => {
                try {
                    this.$axios
                        .$get(`/api/v1/content?url=${el}`)
                        .then((res) => {
                            this.articles = [...this.articles, res.data]
                        })
                        .catch((e) => {
                            // eslint-disable-next-line no-console
                            console.warn('Failed getting item: ', e)
                        })
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.warn('Failed getting item: ', e)
                }
            })
        }
    },
}
